export const fr = {
  brand: {
    name: "Green Horizon Project",
    short: "GHP",
    tagline: "Association loi 1901 — Sussac, Haute-Vienne",
    message: "La recherche climatique de demain commence par les questions que nous posons aujourd'hui.",
    messageNote: "Une orientation de marque — non une citation scientifique."
  },
  nav: {
    association: "L'association",
    research: "Recherche",
    join: "Rejoindre",
    mission: "Notre mission",
    histoire: "Notre histoire",
    transparence: "Transparence",
    recherche: "Recherche scientifique",
    centre: "Le futur Centre",
    programme: "Programme scientifique",
    roadmap: "Feuille de route",
    scientifiques: "Réseau scientifique",
    partenariats: "Partenariats",
    soutenir: "Soutenir la recherche",
    actualites: "Actualités",
    ressources: "Ressources",
    contact: "Contact",
    participate: "Participer",
    menu: "Menu",
    close: "Fermer"
  },
  status: {
    done: "Réalisé — documenté",
    progress: "En cours",
    prep: "En préparation",
    vision: "Vision future"
  },
  forms: {
    name: "Nom et prénom",
    email: "Adresse email",
    organization: "Organisation (facultatif)",
    subject: "Objet",
    message: "Votre message",
    profile: "Votre profil",
    domain: "Domaine d'expertise",
    orgType: "Type d'organisation",
    supportType: "Type de soutien envisagé",
    proposalTitle: "Titre de la proposition",
    consent: "J'accepte que mes données soient traitées dans le cadre de ma demande, conformément à la politique de confidentialité.",
    sending: "Envoi en cours…",
    success: "Votre message a bien été envoyé. Nous vous répondrons prochainement.",
    error: "Une erreur est survenue. Merci de réessayer.",
    newsletterSuccess: "Inscription confirmée. Merci de votre intérêt.",
    requiredNote: "Tous les champs marqués sont requis.",
    fonction: "Fonction (facultatif)",
    pays: "Pays",
    site: "Profil / site professionnel (facultatif)",
    contribution: "Type de contribution envisagée",
    contributionOptions: ["Recherche scientifique", "Encadrement / expertise", "Ingénierie et développement technique", "Missions et données de terrain", "Partenariat institutionnel", "Conseil scientifique", "Autre"],
    profileOptions: ["Chercheur / Chercheuse", "Enseignant-chercheur", "Ingénieur / Ingénieure", "Professeur / Professeure", "Technicien / Technicienne", "Étudiant / Jeune chercheur", "Spécialiste des enjeux climatiques", "Professionnel de l'environnement ou de l'énergie", "Inventeur / Inventrice", "Autre"],
    orgTypeOptions: ["Université", "Laboratoire", "Organisme de recherche", "École d'ingénieurs", "Bureau d'études", "Entreprise technologique", "Collectivité", "Institution publique", "Organisation environnementale", "Organisation internationale", "Fondation / Mécène", "Autre"],
    supportTypeOptions: ["Adhésion", "Don", "Mécénat", "Partenariat privé", "Subvention publique", "Appel à projets", "Convention", "Soutien matériel ou technologique", "Expertise ou compétences", "Autre"]
  },
  footer: {
    baseline: "Association française dédiée à la compréhension des changements climatiques et à la recherche de solutions durables.",
    explore: "Explorer",
    researchCol: "Recherche",
    legal: "Informations",
    newsletterTitle: "Suivre la construction du projet",
    newsletterText: "Recevez les étapes clés de la préparation du futur Centre de recherche.",
    newsletterPlaceholder: "Votre adresse email",
    newsletterButton: "S'inscrire",
    legalLine: "Association régie par la loi du 1er juillet 1901 — Siège : 99 Route de la Croisille-sur-Briance, 87130 Sussac, France",
    mentions: "Mentions légales",
    privacy: "Politique de confidentialité",
    rights: "Tous droits réservés.",
    socialSoon: "Nos réseaux sociaux seront lancés prochainement.",
    socialTitle: "Réseaux sociaux — lancement prochain"
  },
  home: {
    metaTitle: "Green Horizon Project — Préparer la recherche climatique de demain",
    metaDesc: "Association française loi 1901 basée à Sussac (Haute-Vienne). Projet structurant : préparer la création d'un Centre de recherche dédié au climat mondial.",
    heroOverline: "Association loi 1901 — Sussac, Haute-Vienne, France",
    heroLines: ["Préparer la recherche", "scientifique pour répondre", "aux défis climatiques", "de demain."],
    heroText: "Green Horizon Project est une association française dédiée à la lutte contre les effets du changement climatique, à la protection de l'environnement et à l'accompagnement de la transition énergétique. Notre ambition : construire progressivement un écosystème scientifique et technique capable de contribuer à la compréhension des transformations climatiques et à la recherche de solutions durables. Notre projet structurant : préparer la création d'un Centre de recherche dédié au climat.",
    ctaVision: "Découvrir notre vision",
    ctaJoin: "Participer au projet",
    marquee: ["Comprendre le climat", "Anticiper les transformations", "Rechercher des solutions durables", "Science", "Données", "Territoire", "Innovation", "Coopération"],
    visionOverline: "Notre vision",
    visionTitle: "Une démarche scientifique, au service du climat et des territoires",
    pillars: [
      { num: "01", title: "Comprendre le climat", text: "Réunir et produire les connaissances nécessaires à la compréhension des transformations climatiques, à toutes les échelles." },
      { num: "02", title: "Anticiper les transformations", text: "Identifier les trajectoires possibles et les données à produire pour éclairer les décisions de demain." },
      { num: "03", title: "Rechercher des solutions durables", text: "Transformer les connaissances scientifiques en solutions concrètes, testables et utiles aux territoires." }
    ],
    bridgeOverline: "Un pont entre les mondes",
    bridgeTitle: "Connecter les savoirs, les outils et les acteurs",
    bridgeItems: ["Recherche scientifique", "Ingénierie", "Innovation", "Observation du terrain", "Transition énergétique", "Protection de l'environnement", "Coopération institutionnelle", "Transmission des connaissances"],
    centreOverline: "Projet structurant — en préparation",
    centreTitle: "Le futur Centre de recherche sur le climat mondial",
    centreText: "Le Centre de recherche n'existe pas encore : c'est l'ambition qui structure toute l'action de Green Horizon Project. Préparer sa création, c'est dès aujourd'hui fédérer les compétences, définir les programmes et construire les partenariats qui le rendront possible.",
    centreCta: "Découvrir le projet",
    timelineOverline: "Repères",
    timelineTitle: "Une trajectoire assumée",
    timelineItems: [
      { date: "31 octobre 2022", label: "Création statutaire de l'association à Limoges" },
      { date: "17 avril 2025", label: "Assemblée générale extraordinaire : nouvelle dynamique" },
      { date: "Demain", label: "Le Centre de recherche sur le climat mondial" }
    ],
    timelineCta: "Notre histoire",
    manifestoOverline: "Notre conviction",
    ctaTitle: "Construire cette ambition demande des alliances.",
    ctaText: "Chercheurs, ingénieurs, institutions, entreprises, mécènes : chaque compétence compte dans la préparation du futur Centre de recherche.",
    cta1: "Rejoindre le réseau scientifique",
    cta2: "Proposer un partenariat",
    cta3: "Soutenir GHP"
  },
  mission: {
    metaTitle: "Notre mission — Green Horizon Project",
    metaDesc: "Comprendre le climat, anticiper les transformations, rechercher des solutions durables : la mission de l'association Green Horizon Project.",
    overline: "Notre mission",
    titleLines: ["Comprendre. Anticiper.", "Rechercher."],
    intro: "Green Horizon Project est née d'une conviction : les réponses aux défis climatiques passeront par la recherche scientifique, l'innovation technologique et la coopération entre les acteurs. L'association œuvre à la lutte contre les effets du changement climatique global, à la promotion et à la protection de l'environnement, et à l'accompagnement de la transition énergétique.",
    positionOverline: "Positionnement",
    positionTitle: "Cinq dimensions, une seule démarche",
    positions: [
      { title: "Scientifique", text: "La rigueur de la méthode comme fondation : questions précises, données vérifiables, résultats documentés." },
      { title: "Environnemental", text: "La protection de l'environnement comme horizon de chaque travail envisagé." },
      { title: "Technologique", text: "L'ingénierie et l'innovation comme leviers de mesure, de modélisation et d'action." },
      { title: "Territorial", text: "Ancrée dans un territoire rural français, ouverte sur les enjeux climatiques mondiaux." },
      { title: "International", text: "Le climat ne connaît pas de frontières : la coopération scientifique non plus." }
    ],
    principlesOverline: "Nos principes de communication",
    principlesTitle: "Parler de ce qui compte vraiment",
    principles: [
      "Quelles connaissances nous manquent ?",
      "Quelles données devons-nous produire ?",
      "Quelles solutions pouvons-nous tester ?",
      "Comment transformer la recherche en impact ?"
    ],
    principlesNote: "Notre communication se veut crédible, scientifique, transparente, ambitieuse, sobre, internationale et orientée solutions."
  },
  histoire: {
    metaTitle: "Notre histoire — Green Horizon Project",
    metaDesc: "De la création statutaire à Limoges le 31 octobre 2022 à la nouvelle dynamique impulsée en 2025 : l'histoire de Green Horizon Project.",
    overline: "Notre histoire",
    titleLines: ["Une association,", "une trajectoire."],
    intro: "L'histoire de Green Horizon Project est documentée par deux sources principales : les statuts constitutifs, adoptés le 31 octobre 2022 à Limoges, et le procès-verbal de l'assemblée générale extraordinaire du 17 avril 2025. Rien d'autre n'est affirmé sans source.",
    items: [
      {
        date: "31 octobre 2022",
        title: "Création statutaire — Limoges",
        text: "Création de Green Horizon Project et adoption des statuts constitutifs. Ceux-ci définissent l'objet climatique, environnemental et énergétique de l'association, ainsi que l'ambition de rechercher les moyens nécessaires à la création d'un futur Centre de recherche sur le climat mondial.",
        status: "done"
      },
      {
        date: "2023 – 2024",
        title: "Premières années de fonctionnement",
        text: "L'association connaît ses premières années de fonctionnement, avec en 2024 des difficultés liées notamment à l'éloignement géographique du trésorier. Cette période est présentée avec sobriété : les activités de ces années ne font pas l'objet, à ce stade, d'une documentation publique détaillée.",
        status: "done"
      },
      {
        date: "17 avril 2025",
        title: "Assemblée générale extraordinaire — Limoges",
        text: "Cette assemblée marque une nouvelle dynamique et une réorganisation de la gouvernance. Sont élus : M. Cyril Mulumba Mukendi, Président, et Mme Marie-Odile Isabelle Basthier, Secrétaire ; le poste de trésorier demeure vacant jusqu'à nouvel ordre. M. Marcel Samuel Kadima Kalonji demeure membre fondateur hors Bureau et Mme Émilie Millet demeure animatrice des activités de terrain.",
        status: "done"
      },
      {
        date: "2026",
        title: "Structuration et réflexion",
        text: "Nouvelle période de structuration et de réflexion autour de l'avenir de Green Horizon Project : présence numérique, veille scientifique, réseau de compétences et recherche de collaborations pertinentes.",
        status: "progress"
      },
      {
        date: "À terme",
        title: "Vers le futur Centre",
        text: "Poursuite progressive de la construction du projet et, lorsque les conditions seront réunies, développement des travaux scientifiques puis création du futur Centre de recherche sur le climat mondial. Aucune date n'est fixée.",
        status: "vision"
      }
    ],
    legendTitle: "Notre règle de lecture",
    legendText: "Ce qui est réalisé est documenté. Ce qui est en préparation est identifié comme tel. Ce qui relève de la vision future est présenté comme une ambition."
  },
  recherche: {
    metaTitle: "Recherche scientifique — Green Horizon Project",
    metaDesc: "L'approche scientifique de Green Horizon Project : poser les bonnes questions, produire les données, tester les solutions.",
    overline: "Recherche scientifique",
    titleLines: ["La recherche de demain commence", "par les questions d'aujourd'hui."],
    intro: "Green Horizon Project ne revendique à ce jour aucun travail de recherche publié. Cette page présente une orientation : la manière dont l'association entend aborder la science du climat lorsque son écosystème de recherche sera constitué.",
    blocksOverline: "Notre approche",
    blocksTitle: "Quatre questions qui structurent notre démarche",
    blocks: [
      { num: "01", title: "Que voulons-nous comprendre ?", text: "L'évolution des phénomènes climatiques, leurs effets sur les territoires, les dynamiques de la transition énergétique : définir des objets de recherche précis est notre premier chantier." },
      { num: "02", title: "Quelles données produire ?", text: "Aucune recherche crédible sans données fiables. Observation, mesure, croisement de sources ouvertes : la donnée est la matière première du futur Centre." },
      { num: "03", title: "Quelles solutions tester ?", text: "Technologiques, organisationnelles, territoriales : identifier des réponses concrètes aux effets du changement climatique et les soumettre à l'épreuve du réel." },
      { num: "04", title: "Comment créer de l'impact ?", text: "Transformer les connaissances scientifiques en solutions utilisables par les territoires, les entreprises et les institutions." }
    ],
    honestyTitle: "Notre engagement d'honnêteté",
    honestyText: "Ce site distingue systématiquement ce qui est réalisé, ce qui est en préparation et ce qui relève de la vision future. Aucune publication, aucun résultat, aucun partenariat n'est présenté sans source vérifiable.",
    cta: "Explorer le programme scientifique"
  },
  centre: {
    metaTitle: "Le futur Centre de recherche — Green Horizon Project",
    metaDesc: "Construire aujourd'hui l'infrastructure scientifique de demain : le projet de Centre de recherche sur le climat mondial porté par Green Horizon Project.",
    overline: "Projet structurant — en préparation",
    titleLines: ["Le futur Centre", "de recherche"],
    subtitle: "Construire aujourd'hui l'infrastructure scientifique de demain.",
    disclaimer: "Le Centre de recherche n'existe pas encore. Cette page présente une ambition structurante de l'association : ses orientations, son architecture envisagée et les étapes de sa préparation.",
    vocationOverline: "Vocation du futur Centre",
    vocationTitle: "Ce que le Centre aura vocation à devenir",
    vocations: [
      "Conduire ou coordonner des travaux de recherche sur le climat",
      "Réunir chercheurs, ingénieurs, techniciens et experts",
      "Développer des collaborations scientifiques durables",
      "Étudier les effets du changement climatique",
      "Identifier des solutions durables et testables",
      "Transformer les résultats scientifiques en solutions concrètes",
      "Organiser des missions et études de terrain",
      "Collaborer avec institutions, universités, entreprises et organismes spécialisés"
    ],
    axesOverline: "Ce que sa construction nécessitera",
    axesTitle: "Des conditions à réunir, progressivement",
    axesNote: "L'organisation scientifique future du Centre reste volontairement ouverte : les axes de recherche définitifs seront déterminés à partir des travaux réellement menés.",
    axes: [
      { num: "01", title: "Des compétences", text: "Réunir progressivement les savoirs scientifiques, techniques et humains nécessaires." },
      { num: "02", title: "Des chercheurs et experts", text: "Constituer un réseau de compétences engagé autour du projet." },
      { num: "03", title: "Des collaborations", text: "Travailler avec des institutions, universités, entreprises et organisations." },
      { num: "04", title: "Des infrastructures", text: "Préparer les moyens matériels et organisationnels de la recherche." },
      { num: "05", title: "Des ressources financières", text: "Rechercher financements publics et privés, mécénat et subventions." },
      { num: "06", title: "Des partenariats", text: "Construire des alliances durables — locales, nationales et internationales." },
      { num: "07", title: "Des travaux scientifiques préalables", text: "Engager d'abord des travaux et une veille qui fonderont la légitimité du Centre." }
    ],
    ctaTitle: "Ce Centre se construira avec celles et ceux qui croient à la science utile.",
    cta1: "Rejoindre le réseau scientifique",
    cta2: "Voir la feuille de route"
  },
  programme: {
    metaTitle: "Programme scientifique — Green Horizon Project",
    metaDesc: "Les recherches futures de Green Horizon Project : domaines envisagés, questions de recherche, méthodologies et collaborations recherchées.",
    overline: "Programme scientifique",
    titleLines: ["Les recherches futures", "de Green Horizon Project"],
    intro: "Cette page est une plateforme évolutive : elle se nourrira des travaux préparatoires du futur Centre. Chaque domaine présenté ci-dessous est une piste de réflexion structurée — problématique, questions, méthodologie envisagée, données nécessaires, collaborations recherchées, résultats attendus. Aucun résultat scientifique n'est publié à ce jour. Les axes de recherche définitifs seront précisés ultérieurement, en fonction des travaux scientifiques réellement engagés.",
    labels: {
      problematique: "Problématique",
      questions: "Questions de recherche",
      methodologie: "Méthodologie envisagée",
      donnees: "Données nécessaires",
      collaborations: "Collaborations recherchées",
      resultats: "Résultats attendus"
    },
    domains: [
      {
        title: "Comprendre les dynamiques climatiques",
        problematique: "Comment mieux comprendre l'évolution des phénomènes climatiques à l'échelle locale et mondiale ?",
        questions: ["Quels indicateurs suivre pour qualifier les transformations climatiques locales ?", "Comment articuler données climatiques globales et observations de terrain ?", "Quels territoires témoins pour suivre des évolutions dans la durée ?"],
        methodologie: "Revue de littérature scientifique, collecte et croisement de données ouvertes, études de cas territoriales.",
        donnees: "Séries climatologiques, données d'observation environnementale, données socio-territoriales.",
        collaborations: "Laboratoires, universités, organismes d'observation, collectivités territoriales.",
        resultats: "Cartographies, notes de synthèse et hypothèses de recherche structurantes pour le futur Centre."
      },
      {
        title: "Transition énergétique durable",
        problematique: "Quelles solutions technologiques peuvent contribuer à une transition énergétique durable ?",
        questions: ["Quelles technologies sont matures, lesquelles restent à éprouver ?", "Comment évaluer la pertinence d'une solution à l'échelle d'un territoire rural ?", "Quels freins techniques et organisationnels lever en priorité ?"],
        methodologie: "Veille technologique, analyses comparatives, études de faisabilité en conditions réelles.",
        donnees: "Données de production et de consommation énergétiques, retours d'expérience documentés, données territoriales.",
        collaborations: "Écoles d'ingénieurs, bureaux d'études, entreprises technologiques, collectivités.",
        resultats: "Études comparatives, référentiels d'évaluation, scénarios de transition territoriaux."
      },
      {
        title: "De la connaissance à l'action territoriale",
        problematique: "Comment transformer les connaissances scientifiques en solutions concrètes pour les territoires ?",
        questions: ["Quels mécanismes permettent de passer d'un résultat scientifique à une solution déployée ?", "Comment associer les habitants et les acteurs locaux à la démarche de recherche ?", "Comment mesurer l'impact réel d'une solution durable ?"],
        methodologie: "Recherche-action, expérimentations pilotes, indicateurs d'impact co-construits.",
        donnees: "Données d'usage, enquêtes de terrain, indicateurs environnementaux et sociaux.",
        collaborations: "Collectivités, institutions publiques, organisations environnementales, universités.",
        resultats: "Protocoles de transfert, guides méthodologiques, premières expérimentations documentées."
      }
    ],
    honestyNote: "Ces domaines décrivent des intentions de recherche. Ils évolueront avec la constitution du réseau scientifique et les arbitrages du futur Collège Scientifique.",
    formOverline: "Contribuer",
    formTitle: "Proposer un projet de recherche",
    formText: "Vous portez une question de recherche en lien avec nos axes ? Décrivez-la : elle nourrira les travaux préparatoires du futur programme scientifique.",
    formSubmit: "Envoyer la proposition"
  },
  scientifiques: {
    metaTitle: "Réseau scientifique — Green Horizon Project",
    metaDesc: "Green Horizon Project fédère chercheurs, ingénieurs, professeurs et techniciens autour de la construction de son futur programme scientifique.",
    overline: "Collège Scientifique — future constitution",
    titleLines: ["Fédérer", "les compétences"],
    intro: "Les statuts de Green Horizon Project prévoient un Collège Scientifique réunissant notamment des chercheurs, des inventeurs, des professeurs, des ingénieurs et des techniciens. Ce collège n'est pas encore constitué : l'association souhaite progressivement réunir autour de son projet les profils scientifiques et techniques capables de contribuer à sa future activité de recherche.",
    profilesOverline: "Profils recherchés",
    profilesTitle: "Six familles de compétences",
    profiles: [
      { title: "Chercheurs & enseignants-chercheurs", text: "Sciences du climat, sciences de l'environnement, énergie, données, sciences sociales de la transition." },
      { title: "Ingénieurs", text: "Énergie, environnement, instrumentation, modélisation, systèmes d'observation." },
      { title: "Professeurs", text: "Enseignement supérieur, encadrement de travaux, transmission des connaissances." },
      { title: "Techniciens", text: "Mesure, instrumentation, maintenance de dispositifs, données de terrain." },
      { title: "Étudiants & jeunes chercheurs", text: "Stages, travaux encadrés, premières contributions aux futurs programmes." },
      { title: "Inventeurs & spécialistes", text: "Innovation technologique, prototypage, expertise des enjeux climatiques, professionnels de l'environnement et de l'énergie." }
    ],
    calloutTitle: "Vous êtes chercheur, ingénieur, professeur, technicien ou spécialiste des enjeux climatiques ?",
    calloutText: "Rejoindre le réseau ne constitue pas un recrutement pour un laboratoire existant : il s'agit d'identifier les personnes intéressées par la construction du futur programme scientifique de Green Horizon Project.",
    formTitle: "Rejoindre le réseau scientifique",
    formSubmit: "Rejoindre le réseau"
  },
  partenariats: {
    metaTitle: "Partenariats scientifiques — Green Horizon Project",
    metaDesc: "Green Horizon Project prépare la constitution d'un réseau de partenaires : universités, laboratoires, entreprises, collectivités, fondations.",
    overline: "Partenariats scientifiques",
    titleLines: ["Construire un réseau", "de partenaires"],
    intro: "La création du futur Centre de recherche suppose des alliances. Green Horizon Project prépare la constitution progressive d'un réseau de partenaires scientifiques, technologiques, territoriaux et financiers.",
    targetsOverline: "Collaborations recherchées",
    targetsTitle: "À qui souhaitons-nous parler ?",
    targets: [
      "Universités", "Laboratoires", "Organismes de recherche", "Écoles d'ingénieurs",
      "Bureaux d'études", "Entreprises technologiques", "Collectivités", "Institutions publiques",
      "Organisations environnementales", "Fondations", "Mécènes"
    ],
    honestyTitle: "Un point de transparence",
    honestyText: "Green Horizon Project ne revendique à ce jour aucun partenariat institutionnel formalisé. Cette page présente les types de collaborations recherchées — et rien d'autre.",
    formTitle: "Proposer un partenariat",
    formText: "Votre organisation souhaite explorer une collaboration ? Écrivez-nous : chaque proposition est étudiée par le Bureau de l'association.",
    formSubmit: "Proposer un partenariat"
  },
  roadmap: {
    metaTitle: "Feuille de route — Green Horizon Project",
    metaDesc: "La feuille de route stratégique de Green Horizon Project : structuration, préparation scientifique, lancement du Centre, développement international.",
    overline: "Feuille de route",
    titleLines: ["Une vision évolutive,", "en cinq jalons"],
    intro: "Cette feuille de route est une vision évolutive, volontairement générale : Green Horizon Project ne dispose pas encore d'un calendrier scientifique définitif ni d'un programme expérimental arrêté. Elle décrit une trajectoire, pas un plan d'action détaillé.",
    phases: [
      {
        num: "Aujourd'hui",
        period: "",
        title: "Structurer",
        status: "progress",
        items: ["Structurer l'association", "Développer sa présence autour des enjeux climatiques, environnementaux et scientifiques", "Consolider la gouvernance issue de l'assemblée générale de 2025"]
      },
      {
        num: "Progressivement",
        period: "",
        title: "Réfléchir et fédérer",
        status: "prep",
        items: ["Développer une réflexion scientifique et une veille", "Constituer un réseau de compétences", "Rechercher des collaborations pertinentes"]
      },
      {
        num: "À terme",
        period: "",
        title: "Engager les travaux",
        status: "vision",
        items: ["Engager progressivement des travaux scientifiques et expérimentaux, lorsque les conditions seront réunies"]
      },
      {
        num: "Ensuite",
        period: "",
        title: "Préciser les axes",
        status: "vision",
        items: ["Les travaux réellement menés permettront de préciser progressivement les futurs axes de recherche"]
      },
      {
        num: "À plus long terme",
        period: "",
        title: "Créer le Centre",
        status: "vision",
        items: ["Envisager la création et la structuration du Centre de recherche sur le climat mondial"]
      }
    ],
    note: "Cette trajectoire n'annonce aucune date de création du Centre, aucune ouverture de laboratoire, aucun effectif ni aucun objectif chiffré. Il s'agit d'une vision évolutive, et non d'un calendrier opérationnel."
  },
  soutenir: {
    metaTitle: "Soutenir la recherche — Green Horizon Project",
    metaDesc: "Dons, mécénat, partenariats, appels à projets : soutenez la préparation du futur Centre de recherche sur le climat de Green Horizon Project.",
    overline: "Soutenir la recherche",
    titleLines: ["Construisons ensemble", "le futur Centre de recherche"],
    intro: "Préparer un Centre de recherche demande des moyens : humains, scientifiques, matériels et financiers. Les statuts de l'association prévoient explicitement la recherche de financements — dons, legs, cessions de biens immobiliers ou matériels, et tout autre moyen légal nécessaire à la réalisation de sa vision.",
    optionsOverline: "Modalités",
    optionsTitle: "Huit manières de contribuer",
    options: [
      { title: "Adhésion", text: "Rejoindre l'association comme membre et participer à sa vie statutaire." },
      { title: "Dons", text: "Soutien financier direct aux travaux de préparation — via PayPal (solution temporaire) ou par convention." },
      { title: "Mécénat", text: "Engagement d'entreprise : financier, en compétences ou en nature." },
      { title: "Partenariats", text: "Collaborations avec entreprises technologiques, bureaux d'études et organisations." },
      { title: "Subventions & appels à projets", text: "Dispositifs publics, programmes nationaux ou européens, lorsque l'association y est éligible." },
      { title: "Conventions", text: "Accords-cadres avec institutions, universités et organismes." },
      { title: "Soutien matériel & technologique", text: "Équipements, instrumentation, infrastructures : le concret compte autant que le financier." },
      { title: "Expertise & compétences", text: "Mise à disposition de compétences scientifiques, techniques ou juridiques." }
    ],
    noAmountNote: "Par transparence, aucun montant ni objectif de collecte n'est affiché à ce stade : ils seront définis et publiés après validation par l'association.",
    formTitle: "Soutenir le projet",
    formText: "Dites-nous comment vous souhaitez contribuer : nous vous recontacterons pour construire ensemble la modalité adaptée.",
    formSubmit: "Soutenir GHP",
    otherCtas: ["Devenir partenaire", "Proposer un projet"]
  },
  actualites: {
    metaTitle: "Actualités — Green Horizon Project",
    metaDesc: "Le journal de bord de Green Horizon Project : avancement des travaux préparatoires du futur Centre de recherche sur le climat.",
    overline: "Actualités",
    titleLines: ["Le journal de bord", "du projet"],
    emptyTitle: "Le programme scientifique de GHP est actuellement en construction.",
    emptyText: "Nous ne publions que du contenu réel et vérifiable. Les premières actualités — gouvernance, réseau scientifique, partenariats, appels à projets — seront publiées ici dès qu'elles seront documentées.",
    themesOverline: "À venir dans ce journal",
    themesTitle: "Ce dont nous parlerons",
    themes: [
      "Climat et recherche scientifique", "Transition énergétique", "Innovations",
      "Environnement", "Appels à projets", "Conférences",
      "Travaux préparatoires du Centre", "Partenariats", "Événements"
    ],
    sourcesOverline: "Sources de référence",
    sourcesTitle: "Les sources fiables que nous suivons",
    sourcesText: "Notre agent éditorial croise chaque mois les publications de ces institutions pour composer la revue de veille. Ce sont des références publiques et vérifiables.",
    sources: [
      { name: "GIEC — IPCC", url: "https://www.ipcc.ch", desc: "Évaluations scientifiques de référence sur l'évolution du climat" },
      { name: "OMM — WMO", url: "https://wmo.int", desc: "Données météorologiques et climatiques mondiales" },
      { name: "Copernicus C3S", url: "https://climate.copernicus.eu", desc: "Service européen d'observation du changement climatique" },
      { name: "NASA Climate", url: "https://climate.nasa.gov", desc: "Indicateurs climatiques globaux et observation satellitaire" },
      { name: "NOAA", url: "https://www.noaa.gov", desc: "Océans, atmosphère et données climatiques" },
      { name: "ADEME", url: "https://www.ademe.fr", desc: "Transition écologique et énergétique en France" },
      { name: "Météo-France", url: "https://meteofrance.com", desc: "Observations et données climatiques françaises" },
      { name: "Haut Conseil pour le Climat", url: "https://www.hautconseilclimat.fr", desc: "Instance indépendante d'évaluation des politiques climatiques françaises" }
    ],
    newsletterTitle: "Être informé des prochaines étapes",
    newsletterText: "Laissez votre adresse : vous recevrez les jalons réels du projet, sans enjolivement."
  },
  ressources: {
    metaTitle: "Publications et ressources — Green Horizon Project",
    metaDesc: "La base documentaire de Green Horizon Project : statuts, procès-verbaux, rapports et futures publications scientifiques.",
    overline: "Publications & ressources",
    titleLines: ["La base", "documentaire"],
    intro: "Cette bibliothèque accueillera progressivement les documents officiels et scientifiques de l'association. Son architecture est prête ; les documents seront publiés au fil de leur validation par le Bureau.",
    categories: [
      { title: "Statuts", text: "Statuts constitutifs adoptés le 31 octobre 2022 à Limoges." },
      { title: "Procès-verbaux", text: "Compte rendu de l'assemblée générale extraordinaire du 17 avril 2025 et futures assemblées." },
      { title: "Rapports d'activité", text: "Bilans annuels de l'action de l'association." },
      { title: "Rapports financiers", text: "Documents financiers et d'emploi des ressources." },
      { title: "Documents scientifiques", text: "Notes de cadrage et documents de travail du futur programme." },
      { title: "Notes de recherche", text: "Notes méthodologiques et hypothèses de travail." },
      { title: "Rapports de projets", text: "Comptes rendus des études et missions futures." },
      { title: "Publications", text: "Travaux scientifiques publiés, lorsqu'ils existeront." },
      { title: "Communiqués", text: "Prises de position et annonces officielles de l'association." }
    ],
    emptyLabel: "Aucun document publié pour le moment",
    note: "Conformément à notre principe de transparence, seuls des documents réels et validés seront publiés ici."
  },
  transparence: {
    metaTitle: "Transparence — Green Horizon Project",
    metaDesc: "La crédibilité comme principe : ce qui est réalisé est documenté, ce qui est en préparation est identifié, ce qui relève de la vision est assumé comme ambition.",
    overline: "Transparence",
    titleLines: ["La crédibilité", "comme principe"],
    intro: "Green Horizon Project est une jeune association, avec une ambition élevée et une communication sobre. Cette page formalise notre règle : ne jamais embellir artificiellement notre niveau d'activité.",
    ruleTitle: "Notre règle de lecture",
    rules: [
      { label: "Réalisé", text: "Ce qui est réalisé est documenté — statuts, assemblée générale, faits vérifiables." },
      { label: "En préparation", text: "Ce qui est en cours ou en préparation est identifié comme tel, sans être présenté comme acquis." },
      { label: "Vision future", text: "Ce qui relève de l'avenir — le Centre de recherche, les programmes, les partenariats — est présenté comme une ambition, jamais comme une réalité." }
    ],
    govOverline: "Gouvernance",
    govTitle: "Ce que nous pouvons documenter aujourd'hui",
    govItems: [
      "Association régie par la loi du 1er juillet 1901 et le décret du 16 août 1901",
      "Statuts constitutifs adoptés le 31 octobre 2022 à Limoges — durée illimitée",
      "Association déclarée le 7 novembre 2022 — RNA W872015875 · SIREN 923 445 043 · champ ESS",
      "Siège de l'association : 99 Route de la Croisille-sur-Briance, 87130 Sussac",
      "Bureau reconfiguré par l'assemblée générale extraordinaire du 17 avril 2025 à Limoges",
      "Président : M. Cyril Mulumba Mukendi",
      "Secrétaire : Mme Marie-Odile Isabelle Basthier",
      "Trésorerie : poste vacant jusqu'à nouvel ordre (décision de l'assemblée du 17 avril 2025)",
      "Membre fondateur hors Bureau : M. Marcel Samuel Kadima Kalonji",
      "Animatrice des activités de terrain : Mme Émilie Millet"
    ],
    pendingOverline: "En cours de validation",
    pendingTitle: "À valider par Green Horizon Project",
    pendingText: "Les éléments suivants sont en cours de validation par l'association et seront publiés dès confirmation :",
    pending: [
      "Comptes officiels de réseaux sociaux"
    ]
  },
  contact: {
    metaTitle: "Contact — Green Horizon Project",
    metaDesc: "Contactez l'association Green Horizon Project, basée à Sussac (Haute-Vienne). Réponse en français ou en anglais.",
    overline: "Contact",
    titleLines: ["Écrivez-nous"],
    intro: "Une question, une proposition, une envie de contribuer ? Ce formulaire est la porte d'entrée officielle de l'association.",
    infoTitle: "L'association",
    infoItems: [
      { label: "Statut", value: "Association régie par la loi du 1er juillet 1901" },
      { label: "Siège", value: "99 Route de la Croisille-sur-Briance — 87130 Sussac, France" },
      { label: "Email", value: "contact@greenhorizonproject.org" },
      { label: "Fondation statutaire", value: "31 octobre 2022, Limoges" },
      { label: "Langues", value: "Français · English" }
    ],
    emailNote: "Vous préférez écrire directement ? Notre adresse officielle est indiquée ci-dessus. Le formulaire reste le canal privilégié pour une réponse rapide.",
    formTitle: "Contact général",
    formSubmit: "Envoyer le message"
  },
  legal: {
    mentionsTitle: "Mentions légales",
    mentionsMeta: "Mentions légales du site de l'association Green Horizon Project.",
    mentionsSections: [
      { title: "Éditeur du site", text: "Green Horizon Project (GHP), association régie par la loi du 1er juillet 1901. Statuts adoptés le 31 octobre 2022 à Limoges. Siège : 99 Route de la Croisille-sur-Briance, 87130 Sussac, France." },
      { title: "Immatriculation", text: "Association déclarée, enregistrée le 7 novembre 2022 sous le numéro RNA W872015875. SIREN : 923 445 043 — SIRET : 923 445 043 00014. Code APE : 94.99Z (autres organisations fonctionnant par adhésion volontaire). L'association appartient au champ de l'économie sociale et solidaire (ESS)." },
      { title: "Directeur de la publication", text: "Le Président de l'association, M. Cyril Mulumba Mukendi." },
      { title: "Contact", text: "Via le formulaire de contact du site ou par email : contact@greenhorizonproject.org." },
      { title: "Hébergement", text: "Site hébergé sur l'infrastructure Emergent." },
      { title: "Propriété intellectuelle", text: "L'ensemble des contenus de ce site (textes, éléments graphiques) est la propriété de l'association Green Horizon Project, sauf mention contraire. Toute reproduction sans autorisation est interdite." },
      { title: "Informations en cours de validation", text: "Comptes officiels de réseaux sociaux : ces informations seront complétées dès leur création." }
    ],
    privacyTitle: "Politique de confidentialité",
    privacyMeta: "Politique de confidentialité et de protection des données personnelles de Green Horizon Project (RGPD).",
    privacySections: [
      { title: "Responsable de traitement", text: "Green Horizon Project (GHP), association loi 1901, siège : Sussac, Haute-Vienne, France." },
      { title: "Données collectées", text: "Via nos formulaires (réseau scientifique, partenariat, soutien, proposition de projet, contact) et l'inscription à la lettre d'information : nom, adresse email, organisation, contenu du message. Aucune autre donnée personnelle n'est collectée." },
      { title: "Finalités et base légale", text: "Les données sont utilisées exclusivement pour répondre à votre demande et, le cas échéant, vous informer des étapes du projet. Base légale : votre consentement, recueilli par case à cocher obligatoire." },
      { title: "Durée de conservation", text: "Les données sont conservées le temps nécessaire au traitement de votre demande, puis archivées au maximum trois ans, sauf demande de suppression de votre part." },
      { title: "Sous-traitants", text: "Hébergement du site et service d'envoi d'emails transactionnels. Vos données ne sont ni vendues, ni partagées avec des tiers à des fins commerciales." },
      { title: "Vos droits", text: "Conformément au RGPD, vous disposez de droits d'accès, de rectification, d'effacement, de limitation et d'opposition. Exercez-les via le formulaire de contact. Vous pouvez également saisir la CNIL." },
      { title: "Cookies", text: "Ce site ne dépose à ce stade aucun cookie de suivi ou de mesure d'audience." }
    ]
  },
  newsCats: {
    centre: "Travaux du Centre",
    climat: "Climat",
    transition: "Transition énergétique",
    innovation: "Innovation",
    environnement: "Environnement",
    appels: "Appels à projets",
    conferences: "Conférences",
    partenariats: "Partenariats",
    evenements: "Événements",
    vie: "Vie de l'association",
    veille: "Veille climatique"
  },
  adminTypes: {
    network: "Réseau scientifique",
    partner: "Partenariat",
    support: "Soutien au projet",
    project: "Projet de recherche",
    contact: "Contact général"
  },
  admin: {
    loginTitle: "Espace d'administration",
    loginSub: "Réservé au Bureau de l'association",
    email: "Adresse email",
    password: "Mot de passe",
    login: "Se connecter",
    loggingIn: "Connexion…",
    loginError: "Identifiants incorrects ou compte verrouillé temporairement.",
    backToSite: "Retour au site",
    logout: "Déconnexion",
    dashboard: "Tableau de bord",
    tabSubmissions: "Demandes reçues",
    tabNews: "Actualités",
    tabDocs: "Documents",
    all: "Tous",
    delete: "Supprimer",
    confirmDelete: "Confirmer la suppression ?",
    deleted: "Élément supprimé.",
    empty: "Aucun élément pour le moment.",
    submissionsEmpty: "Aucune demande reçue pour le moment.",
    newsNew: "Publier une actualité",
    titleFr: "Titre (FR) *",
    titleEn: "Titre (EN)",
    summaryFr: "Résumé (FR)",
    summaryEn: "Résumé (EN)",
    contentFr: "Contenu (FR) *",
    contentEn: "Contenu (EN)",
    category: "Catégorie",
    publish: "Publier",
    newsSaved: "Actualité publiée.",
    docNew: "Ajouter un document",
    file: "Fichier (PDF de préférence) *",
    descFr: "Description (FR)",
    descEn: "Description (EN)",
    upload: "Ajouter le document",
    docSaved: "Document ajouté.",
    download: "Télécharger",
    receivedOn: "Reçu le",
    agentBtn: "Générer une revue de veille (IA)",
    agentStarted: "Génération lancée — l'article apparaîtra ici d'ici 1 à 2 minutes.",
    agentGenerating: "Génération en cours…",
    newsEdit: "Modifier l'actualité",
    update: "Mettre à jour",
    cancel: "Annuler",
    newsUpdated: "Actualité mise à jour.",
    tabDashboard: "Tableau de bord",
    tabEvents: "Événements",
    tabProjects: "Projets",
    tabNewsletter: "Newsletter",
    eventNew: "Créer un événement",
    eventEdit: "Modifier l'événement",
    eventSaved: "Événement créé.",
    eventUpdated: "Événement mis à jour.",
    date: "Date et heure",
    endDate: "Fin (facultatif)",
    location: "Lieu",
    type: "Type",
    link: "Lien (facultatif)",
    projectNew: "Créer un projet",
    projectEdit: "Modifier le projet",
    projectSaved: "Projet créé.",
    projectUpdated: "Projet mis à jour.",
    status: "Statut",
    subscribers: "Inscrits à la lettre de veille",
    subscribedOn: "Inscrit le",
    statsContacts: "Demandes reçues",
    statsNetwork: "Réseau scientifique",
    statsPartners: "Partenariats",
    statsNewsletter: "Inscrits newsletter",
    statsNews: "Articles publiés",
    statsDocs: "Documents",
    recentSubmissions: "Dernières demandes",
    upcomingEvents: "Prochains événements",
    latestNews: "Derniers articles",
    nothingHere: "Rien à afficher pour le moment."
  },
  newsAgent: {
    title: "Agent éditorial — revue de veille mensuelle",
    desc: "Un agent éditorial croise automatiquement, une fois par mois, les informations publiques disponibles : catastrophes naturelles, rapports du GIEC et des structures climatiques (OMM, Copernicus…), annonces de la société civile, publications de chercheurs et avancées scientifiques dans la lutte contre le réchauffement. Chaque article est publié avec un badge « veille automatisée », notifié par email au Bureau, et peut être supprimé à tout moment.",
    badge: "Veille automatisée — sources publiques"
  },
  paypal: {
    title: "Faire un don via PayPal",
    text: "En attendant l'ouverture du compte bancaire dédié de l'association, les dons sont temporairement reçus sur le compte PayPal du Président (cyrilone2002@hotmail.com). Aucun montant n'est imposé : vous choisissez librement sur la page PayPal sécurisée.",
    cta: "Faire un don via PayPal",
    note: "Solution temporaire décidée par le Bureau — un compte dédié à l'association sera ouvert et communiqué ici."
  },
  ressourcesKeys: ["statuts", "pv", "activite", "financiers", "scientifiques", "notes", "projets", "publications", "communiques"],
  navX: {
    presentation: "Présentation",
    evenements: "Événements",
    projets: "Projets en préparation"
  },
  presentation: {
    metaTitle: "L'association — Green Horizon Project",
    metaDesc: "Green Horizon Project : association loi 1901 déclarée (RNA W872015875), basée à Sussac en Haute-Vienne, dédiée au climat, à l'environnement et à la transition énergétique.",
    overline: "L'association",
    titleLines: ["Green Horizon", "Project"],
    intro: "Une association française réelle, déclarée et documentée, qui prépare progressivement les fondations scientifiques, humaines, techniques, institutionnelles et financières d'un futur Centre de recherche sur le climat mondial.",
    identityOverline: "Identité",
    identityTitle: "Une association déclarée, en règle et documentée",
    identity: [
      { label: "Forme juridique", value: "Association loi du 1er juillet 1901 — déclarée, champ ESS" },
      { label: "RNA", value: "W872015875" },
      { label: "SIREN / SIRET", value: "923 445 043 / 923 445 043 00014" },
      { label: "Siège", value: "99 Route de la Croisille-sur-Briance, 87130 Sussac, France" },
      { label: "Fondation statutaire", value: "31 octobre 2022, Limoges" },
      { label: "Déclaration", value: "7 novembre 2022" },
      { label: "Durée", value: "Illimitée" },
      { label: "Code APE", value: "94.99Z — organisations fonctionnant par adhésion volontaire" }
    ],
    objetOverline: "Objet statutaire",
    objetTitle: "Ce que les statuts prévoient",
    objetIntro: "Adoptés le 31 octobre 2022 à Limoges, les statuts définissent l'objet de l'association et ses orientations :",
    objet: [
      "Lutter contre les effets du changement climatique",
      "Promouvoir et protéger l'environnement",
      "Accompagner la transition énergétique",
      "Rechercher et produire des connaissances",
      "Rechercher des partenariats",
      "Faire participer des personnes compétentes à des travaux spécifiques",
      "Conduire des missions de terrain",
      "Rechercher les financements et moyens nécessaires",
      "Rechercher des solutions durables en faveur du climat mondial",
      "Rechercher les moyens permettant de mettre sur pied un Centre de recherche sur le climat mondial"
    ],
    govOverline: "Gouvernance",
    govTitle: "Le Bureau, selon le procès-verbal du 17 avril 2025",
    govNote: "Composition issue du dernier document interne disponible : l'assemblée générale extraordinaire du 17 avril 2025 à Limoges. Aucun changement ultérieur n'est documenté à ce jour.",
    gov: [
      { role: "Président", name: "M. Cyril Mulumba Mukendi" },
      { role: "Secrétaire", name: "Mme Marie-Odile Isabelle Basthier" },
      { role: "Trésorerie", name: "Poste vacant jusqu'à nouvel ordre" },
      { role: "Membre fondateur hors Bureau", name: "M. Marcel Samuel Kadima Kalonji" },
      { role: "Animatrice des activités de terrain", name: "Mme Émilie Millet" }
    ],
    fonctionnementOverline: "Fonctionnement",
    fonctionnementTitle: "Comment l'association travaille",
    fonctionnement: [
      "L'assemblée générale est l'instance souveraine de l'association.",
      "Le Bureau, élu en assemblée générale, conduit l'action de l'association.",
      "Les statuts prévoient la constitution d'un Collège Scientifique réunissant chercheurs, inventeurs, professeurs, ingénieurs et techniciens — en cours de constitution.",
      "Les statuts prévoient la possibilité de nommer des membres d'honneur."
    ],
    docsCta: "Consulter les documents officiels",
    contactCta: "Contacter l'association"
  },
  events: {
    metaTitle: "Événements — Green Horizon Project",
    metaDesc: "Assemblées générales, conférences, ateliers et rencontres scientifiques de Green Horizon Project.",
    overline: "Événements",
    titleLines: ["Rencontres et", "rendez-vous"],
    intro: "Assemblées générales, rencontres scientifiques, conférences, ateliers et réunions : seuls des événements réels ou officiellement annoncés sont publiés ici.",
    upcoming: "À venir",
    past: "Événements passés",
    emptyTitle: "Aucun événement annoncé pour le moment.",
    emptyText: "Les prochaines assemblées générales, conférences et rencontres seront annoncées ici dès leur officialisation.",
    typesTitle: "Ce que nous organiserons",
    types: ["Assemblées générales", "Rencontres scientifiques", "Conférences", "Réunions de travail", "Ateliers", "Rencontres avec partenaires"],
    typeLabels: { ag: "Assemblée générale", conference: "Conférence", atelier: "Atelier", rencontre: "Rencontre scientifique", reunion: "Réunion", partenaire: "Rencontre partenaire" },
    moreInfo: "Plus d'informations"
  },
  projects: {
    metaTitle: "Projets en préparation — Green Horizon Project",
    metaDesc: "Les futurs projets scientifiques de Green Horizon Project : problématiques, objectifs, partenaires recherchés et états d'avancement, en toute transparence.",
    overline: "Projets scientifiques",
    titleLines: ["Projets", "en préparation"],
    intro: "Cette page présente progressivement les futurs projets scientifiques de Green Horizon Project. Chaque projet est documenté : problématique, contexte, objectif scientifique, état d'avancement, partenaires recherchés, besoins et prochaines étapes.",
    emptyTitle: "Les premiers projets seront publiés ici.",
    emptyText: "Aucun projet n'est publié à ce stade : ils seront présentés dès leur validation par le Bureau, avec leur état d'avancement réel.",
    statusesTitle: "Notre système de statuts",
    statusesText: "Chaque projet porte un statut explicite. Aucun projet n'est présenté comme « terminé » ou « en cours » sans information réelle permettant de le justifier.",
    labels: { contexte: "Contexte", problematique: "Problématique", objectif: "Objectif scientifique", partenaires: "Partenaires recherchés", besoins: "Besoins", etapes: "Prochaines étapes" },
    cta: "Proposer un projet de recherche"
  },
  projectStatuses: {
    idee: "Idée",
    exploration: "En exploration",
    preparation: "En préparation",
    partenaires: "Partenaires recherchés",
    developpement: "En développement",
    termine: "Terminé"
  },
  researchAxes: {
    overline: "Vision scientifique",
    title: "Trois axes, une ambition",
    note: "Ces trois axes constituent la vision scientifique de Green Horizon Project — ils ne représentent pas des résultats déjà obtenus.",
    items: [
      { num: "01", title: "Comprendre le climat", text: "Développer et rassembler les connaissances permettant de mieux comprendre les transformations climatiques." },
      { num: "02", title: "Anticiper les transformations", text: "Étudier les trajectoires possibles et leurs conséquences afin de mieux éclairer les décisions futures." },
      { num: "03", title: "Rechercher des solutions durables", text: "Favoriser la transformation des connaissances en solutions concrètes et durables." }
    ]
  },
  veille: {
    overline: "Veille scientifique",
    title: "Construire une culture scientifique avant le Centre",
    text: "Avant même la création du Centre, Green Horizon Project construit une culture scientifique partagée : une veille mensuelle croise les publications des institutions de référence. Chaque contenu distingue clairement la source externe, l'analyse ou la synthèse, et la position ou le projet de GHP. La revue de veille est envoyée chaque mois par email aux inscrits.",
    themes: ["Climat", "Changement climatique", "Adaptation", "Transition énergétique", "Énergies renouvelables", "Biodiversité", "Eau", "Agriculture et climat", "Résilience territoriale", "Technologies bas carbone", "Stockage de l'énergie", "Observation environnementale"],
    cta: "Lire la revue de veille"
  },
  researchNav: {
    overline: "Explorer",
    title: "Les rubriques scientifiques",
    items: [
      { label: "Programme scientifique", to: "/programme" },
      { label: "Projets en préparation", to: "/projets" },
      { label: "Veille scientifique", to: "/actualites" },
      { label: "Réseau scientifique", to: "/scientifiques" },
      { label: "Le futur Centre", to: "/centre" }
    ]
  },
  centreSteps: {
    overline: "Feuille de route prospective",
    title: "Cinq étapes pour construire le Centre",
    note: "Ces étapes ne sont pas réalisées : elles décrivent le processus envisagé pour construire progressivement le futur Centre.",
    steps: [
      { num: "01", title: "Préparer", items: ["Veille scientifique", "Identification des grands enjeux climatiques", "Documentation", "Structuration des premiers axes de recherche"] },
      { num: "02", title: "Fédérer", items: ["Chercheurs et scientifiques", "Ingénieurs et experts", "Universités et institutions", "Entreprises et organisations environnementales"] },
      { num: "03", title: "Développer", items: ["Projets de recherche", "Études et observations de terrain", "Collaborations", "Projets pilotes"] },
      { num: "04", title: "Financer", items: ["Subventions", "Mécénat et partenariats", "Appels à projets", "Financements publics et privés"] },
      { num: "05", title: "Créer", items: ["Construction progressive du futur Centre, physique et institutionnel"] }
    ]
  },
  threeStates: {
    overline: "Lecture claire",
    title: "Ce qui existe, ce qui est en préparation, ce qui est à construire",
    cols: [
      { label: "Déjà établi", items: ["Association loi 1901 déclarée (RNA W872015875)", "Statuts adoptés le 31 octobre 2022 à Limoges", "Objet climatique et environnemental", "Ambition du futur Centre inscrite dans les statuts", "Bureau reconfiguré le 17 avril 2025"] },
      { label: "En préparation", items: ["Présence scientifique et numérique", "Veille scientifique mensuelle", "Réseau scientifique", "Identification des axes de recherche", "Recherche de partenaires", "Préparation de futurs projets"] },
      { label: "À construire", items: ["Programmes de recherche structurés", "Infrastructures scientifiques", "Centre de recherche physique", "Équipes scientifiques permanentes", "Partenariats institutionnels"] }
    ]
  },
  notFound: {
    title: "Page introuvable",
    text: "La page que vous cherchez n'existe pas ou a été déplacée.",
    cta: "Retour à l'accueil"
  }
};
